function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { MediaDownloadUrlQuery, useLocation } from "@custom/schema";
import React, { useEffect, useState } from "react";
import DownloadLink from "../molecules/AutoDownloadUrl";
import CustomerCta from "./CustomerCta";
// @todo Revise endpoint definition to work on Lagoon envs
var endpoint = "".concat(typeof process !== "undefined" ? process.env.GATSBY_DRUPAL_URL : "", "/graphql");
export default function AutoDownload(props) {
    var _useLocation = _sliced_to_array(useLocation(), 1), location = _useLocation[0];
    var _useState = _sliced_to_array(useState(null), 2), downloadUrl = _useState[0], setDownloadUrl = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), IP = _useState1[0], setIP = _useState1[1];
    var parameters = Object.fromEntries(location.searchParams.entries());
    var media_id = parameters.media_id;
    // Effect to update existing links with data-id="#auto-download"
    useEffect(function() {
        if (downloadUrl === null) return;
        var downloadAnchors = document.querySelectorAll('a[data-id="#auto-download"]');
        downloadAnchors.forEach(function(anchor) {
            if (downloadUrl !== "<empty>" && typeof downloadUrl === "string") {
                anchor.href = downloadUrl;
                anchor.setAttribute("download", "");
                anchor.removeAttribute("data-id");
                anchor.removeAttribute("data-type");
                // Add click handler to ensure download behavior
                var handleClick = function(e) {
                    e.preventDefault();
                    var link = document.createElement("a");
                    link.href = downloadUrl;
                    link.download = "";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                };
                // Remove existing listeners and add new one
                anchor.removeEventListener("click", handleClick);
                anchor.addEventListener("click", handleClick);
            } else {
                anchor.href = "#";
                anchor.removeAttribute("download");
            }
        });
        // Cleanup function to remove event listeners
        return function() {
            downloadAnchors.forEach(function(anchor) {
                anchor.removeEventListener("click", function(e) {
                    return e.preventDefault();
                });
            });
        };
    }, [
        downloadUrl
    ]);
    useEffect(function() {
        var fetchIP = function() {
            var _ref = _async_to_generator(function() {
                var data;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch("https://ip.nf/me.json")
                            ];
                        case 1:
                            data = _state.sent();
                            data.json().then(function(res) {
                                return setIP(res.ip.ip);
                            }).catch(function(err) {
                                return console.log(err);
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchIP() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchIP();
        var fetchDownloads = function() {
            var _ref = _async_to_generator(function() {
                var url, variables;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!media_id) {
                                setDownloadUrl("<empty>");
                                return [
                                    2
                                ];
                            }
                            url = new URL(endpoint, window.location.origin);
                            url.searchParams.set("queryId", MediaDownloadUrlQuery);
                            variables = {
                                media_id: media_id,
                                context: IP
                            };
                            url.searchParams.set("variables", JSON.stringify(variables));
                            return [
                                4,
                                fetch(url, {
                                    credentials: "include",
                                    headers: {
                                        "SLB-Forwarded-Proto": window.location.protocol.slice(0, -1),
                                        "SLB-Forwarded-Host": window.location.hostname,
                                        "SLB-Forwarded-Port": window.location.port
                                    }
                                }).then(function(r) {
                                    return r.json();
                                }).then(function(r) {
                                    var _r_data, _r_data_mediaDownloadUrl;
                                    setDownloadUrl(r === null || r === void 0 ? void 0 : (_r_data = r.data) === null || _r_data === void 0 ? void 0 : (_r_data_mediaDownloadUrl = _r_data.mediaDownloadUrl) === null || _r_data_mediaDownloadUrl === void 0 ? void 0 : _r_data_mediaDownloadUrl.url);
                                    return r;
                                }).catch(function(err) {
                                    return console.log(err);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchDownloads() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchDownloads();
    }, [
        media_id,
        IP
    ]);
    if (!downloadUrl) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, "Please wait..");
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, downloadUrl && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: props.hideAutoDownload ? "invisible" : ""
    }, /*#__PURE__*/ React.createElement(CustomerCta, {
        title: props.message,
        target: downloadUrl !== "<empty>" ? downloadUrl : "#",
        linkText: "Download",
        type: "Download"
    }), downloadUrl !== "<empty>" ? /*#__PURE__*/ React.createElement(DownloadLink, {
        url: downloadUrl
    }) : /*#__PURE__*/ React.createElement(Warning, null))));
}
function Warning() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "relative px-6 md:px-14 mb-16 md:mb-20 xl:mb-44"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mx-auto max-w-7xl",
        role: "alert"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "font-bold"
    }, "Warning"), /*#__PURE__*/ React.createElement("p", null, "There is no associated file to download")))));
}
